import { useState } from 'react';
import type { FlaggedEntitySummary } from 'components/flag-override-modal';

/**
 * The confirm modals a party's actions open: Mark as Correct (with its alias choice), the flag
 * override, Remove, Re-run and Remove Correct Status.
 *
 * @return {object} Each modal's state and setters, and `closeMarkCorrect` / `closeConfirms`.
 */
export function usePartyModals() {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [flaggedForOverride, setFlaggedForOverride] = useState<
    FlaggedEntitySummary[] | null
  >(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [rerunOpen, setRerunOpen] = useState(false);
  const [revertOpen, setRevertOpen] = useState(false);
  const [preserveStaged, setPreserveStaged] = useState(false);
  const [aliasReason, setAliasReason] = useState('');
  // A failed submit, shown inside the confirm that stays open for a retry.
  const [dialogError, setDialogError] = useState<string | null>(null);

  /** Closes Mark as Correct and forgets its alias choice. */
  const closeMarkCorrect = () => {
    setConfirmOpen(false);
    setPreserveStaged(false);
    setAliasReason('');
    setDialogError(null);
  };
  /** Closes every confirm except Mark as Correct, which `closeMarkCorrect` closes. */
  const closeConfirms = () => {
    setDeleteOpen(false);
    setRerunOpen(false);
    setRevertOpen(false);
    setFlaggedForOverride(null);
    setDialogError(null);
  };

  return {
    confirmOpen,
    setConfirmOpen,
    flaggedForOverride,
    setFlaggedForOverride,
    deleteOpen,
    setDeleteOpen,
    rerunOpen,
    setRerunOpen,
    revertOpen,
    setRevertOpen,
    preserveStaged,
    setPreserveStaged,
    aliasReason,
    setAliasReason,
    dialogError,
    setDialogError,
    closeMarkCorrect,
    closeConfirms,
  };
}
